<template>
  <PrintPageLandscape>
    <PresentationPage :page-number="pageNumber" :page-count="pageCount">
      <p class="presentation-page__eyebrow">Selbstauskunft</p>
      <h2 class="presentation-page__title">Selbstauskunft — PV-Investor</h2>
      <p class="presentation-page__text">
        Formular zur Erfassung der relevanten Investor-Daten für die Finanzierung der PV-Anlage.
      </p>
      <div class="presentation-page__form">
        <div class="presentation-page__form-header">Selbstauskunft — PV-Investor</div>
        <div class="presentation-page__form-body">
          <section
            v-for="section in sections"
            :key="section.title"
            class="presentation-page__form-section"
          >
            <h3 class="presentation-page__form-section-title">{{ section.title }}</h3>
            <div class="presentation-page__form-fields">
              <div
                v-for="field in section.fields"
                :key="field.label"
                class="presentation-page__form-field"
              >
                <label class="presentation-page__form-field-label">{{ field.label }}</label>
                <div class="presentation-page__form-field-input" aria-hidden="true"></div>
              </div>
            </div>
          </section>
        </div>
      </div>
      <p class="presentation-page__disclaimer">
        Vorlage zur Erfassung beim Erstgespräch — wird im RETIS-System digital strukturiert
        weitergeführt.
      </p>
    </PresentationPage>
  </PrintPageLandscape>
</template>

<script>
import PrintPageLandscape from '@/components/Print/PrintPageLandscape.vue';
import PresentationPage from '@/views/MasterPresentation/PresentationPage';

export default {
  name: 'MasterPresentationPrintPage41',
  components: { PrintPageLandscape, PresentationPage },
  props: {
    project: { type: Object, default: null },
    pageCount: { type: Number, default: null },
    pageNumber: { type: Number, default: 0 },
  },
  data() {
    return {
      sections: [
        {
          title: 'Persönliche Daten',
          fields: [
            { label: 'Name, Vorname' },
            { label: 'Geburtsdatum' },
            { label: 'Anschrift' },
            { label: 'Familienstand' },
          ],
        },
        {
          title: 'Berufliche Situation',
          fields: [
            { label: 'Beruf / Tätigkeit' },
            { label: 'Arbeitgeber' },
            { label: 'Monatsnetto' },
            { label: 'Selbstständig seit' },
          ],
        },
        {
          title: 'Vermögenslage',
          fields: [
            { label: 'Bankvermögen' },
            { label: 'Wertpapiervermögen' },
            { label: 'Sachwerte' },
            { label: 'zvE letztes Jahr' },
          ],
        },
      ],
    };
  },
};
</script>
